import { useState, useEffect } from "react";
import { apiLoadingState } from "../api/axios";
import "./GlobalLoader.scss";

export default function GlobalLoader() {
    return null; // Tamamen iptal edildi (Kullanıcı isteği)
}
